import * as clsApi from "@/js/api/classroomApi";

export enum FeatureFlag {
	SCREEN_SHARE = "SCREEN_SHARE",
	FOCUS_LOCK_MODE = "FOCUS_LOCK_MODE",
}

export type ClassroomFeatureFlagsResponse = {
	applianceId: string;
	enabledFeatures: string[];
};

export async function getClassroomFeatureFlags(applianceId: string): Promise<ClassroomFeatureFlagsResponse> {
	const data = await clsApi.Get2<ClassroomFeatureFlagsResponse>(`v1/appliances/${applianceId}/enabled-features`);

	// Manually append any feature flags here until supported by the API for local development if desired.
	// Example: data.enabledFeatures.push(FeatureFlag.SCHEDULED_CLASSES_V2);

	return data;
}
